import { Button, Box, Text } from "@chakra-ui/react";
import { useEthers, useEtherBalance } from "@usedapp/core";
import { formatEther } from "@ethersproject/units";
import Identicon from "./Identicon";
type Props = {
  handleOpenModal: any;
}
export default function ConnectButton({handleOpenModal}: Props){
  const {activateBrowserWallet, account } = useEthers();
  const etherBalance = useEtherBalance(account);
  

  function handleConnectWallet() {
    activateBrowserWallet();
  }
  return account ? (
    <Box
    display="flex"
    alignItems="center"
    background="gray.700"
    borderRadius="xl"
    py="0"
  >
    <Box px="3">
      <Text color="white" fontSize="md">
        {/* {etherBalance && etherBalance} ETH */}
        {etherBalance && parseFloat(formatEther(etherBalance)).toFixed(3)} ETH
      </Text>
    </Box>
    <Button
        // add named function to handle opening modal
        onClick={handleOpenModal}
        bg="gray.800"
        border="1px solid transparent"
        _hover={{
          border: "1px",
          borderStyle: "solid",
          borderColor: "blue.400",
          backgroundColor: "gray.700",
        }}
        borderRadius="xl"
        m="1px"
        px={3}
        height="38px"
      >
        <Text color="white" fontSize="md" fontWeight="medium" mr="2">
          {/* check account is defined and then slice the string */}
          {account }
        </Text>
        <Identicon/>
      </Button>
    </Box>
  ) : (
    <Button onClick={handleConnectWallet}>
      Connect to a wallet
    </Button>
  );
}